import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { Image } from "react-native";
import { useFragment } from "react-relay";

import { getThumbnail } from "@whoosh/utilities/src/Cloudinary";

import { ClubLogo_Club$key } from "./__generated__/ClubLogo_Club.graphql";

export const ClubLogo = ({
  clubRef,
}: {
  clubRef: ClubLogo_Club$key | null;
}) => {
  const club = useFragment(ClubLogoFragmentString, clubRef);
  const clubLogoPublicId = club?.logoImage?.publicId;

  return (
    <Image
      source={{
        uri: getThumbnail(clubLogoPublicId, 56, 56)?.toURL(),
      }}
      accessibilityLabel={t`Club Logo`}
      testID="club-logo"
      style={{
        width: 56,
        height: 56,
        borderRadius: 8,
      }}
    />
  );
};

export const ClubLogoFragmentString = graphql`
  fragment ClubLogo_Club on Club {
    logoImage {
      # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
      publicId: renderingKey
    }
  }
`;
